import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Clears the timeouts stored in an array
 * */
export const clearTimeouts = (timeouts: ReturnType<typeof setTimeout>[]): [] => {
  if (!timeouts) return [];
  timeouts.forEach((timeout) => {
    clearTimeout(timeout);
  });
  return [];
};

/**
 * Runs a callback on NavigationStart
 */
export const onNavigationStart = (router: Router, destroy$: Subject<void>, onNavigate: () => void, callDestroy = false): Subscription =>
  router.events.pipe(takeUntil(destroy$)).subscribe((event: RouterEvent) => {
    if (event instanceof NavigationStart) {
      onNavigate();
      if (callDestroy) destroy$.next(); // Will trigger the destroy$ subject
    }
  });
